import { INicheInfo, NicheListWidget } from "components/widgets/NicheListWidget";
import { metricsBus, EventSource, NichePreviewClickInitiator } from "@/common/buses";
import { routes } from "@/common/utils/routes";
import { useAnalyticsStore } from "@/common/store/analyticsStore";

export const NicheListWidgetAlive = (props: {
  title: string;
  link: string;
  className?: string;
  niches: INicheInfo[];
  page: number;
  listSize?: number;
}) => {
  const eventSource = useAnalyticsStore((state) => state.eventSource);

  const onPreviewClick = (nicheId: string, initiator: NichePreviewClickInitiator) => {
    metricsBus.emit("watchPageNavigation", { elementType: "Niche", targetURL: routes.niche(nicheId) });
    metricsBus.emit("nichePreviewClicked", {
      nicheId,
      initiator,
      source: eventSource?.name ?? EventSource.Other,
    });
  };

  return (
    <NicheListWidget
      title={props.title}
      link={props.link}
      className={props.className}
      niches={props.niches}
      page={props.page}
      listSize={props.listSize}
      onPreviewClick={onPreviewClick}
    />
  );
};
